module.exports = __webpack_public_path__ + "static/img/yun2.b368c6a.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/background/yun2.png
// module id = /az7
// module chunks = 1